import { colors } from './colors';
import { typography } from './typography';
import { breakpoints, media } from './breakpoints';

// Shadows
export const shadows = {
  subtle: '0 1px 3px -1px hsl(0 0% 0% / 0.06)',
  soft: '0 2px 8px -2px hsl(0 0% 0% / 0.08)',
  medium: '0 8px 24px -4px hsl(0 0% 0% / 0.12)',
  elevated: '0 16px 48px -8px hsl(0 0% 0% / 0.16)',
};

// Border radius
export const borderRadius = {
  sm: 'calc(1.25rem - 8px)',
  md: 'calc(1.25rem - 4px)',
  lg: '1.25rem',
  xl: '1rem',
  '2xl': '1.25rem',
};

// Spacing
export const spacing = {
  container: {
    padding: '1.5rem',
    maxWidth: {
      default: '1280px',
      '2xl': '1800px', // Increased for better use of large screens
    },
  },
};

// Create theme object
export const createTheme = (mode = 'light') => ({
  mode,
  colors: colors[mode],
  typography,
  breakpoints,
  media,
  shadows,
  borderRadius,
  spacing,
});

export default createTheme;


